import React from 'react'
import styled from 'styled-components'
import R from 'ramda'
import createMeasurement from './Measurements'
import Axis from './Axis'
import { axisBottom, axisLeft } from 'd3-axis'
import { format } from 'd3-format'
import { pure } from 'recompose'

const Circle = styled.circle`
  ${props => props.fill && `fill:${props.fill};`} ${props =>
    props.stroke && `stroke: ${props.stroke};`};
`
const YLabel = styled.text`
  text-anchor: end;
  alignment-baseline: hanging;
`
const XLabel = styled.text`
  text-anchor: end;
  alignment-baseline: baseline;
`

const calcRValue = ({ rValue, rScale, defaultRadius }) =>
  R.isNil(rScale) ? (R.isNil(rValue) ? defaultRadius : rValue) : rScale(rValue)

const ScatterPlot = ({
  measurement = createMeasurement({}),
  rScale,
  fillScale,
  data,
  defaultRadius = 5,
  circleRenderer,
  xFormat = format(',.3s'),
  yFormat = format(',.3s'),
  xLabel,
  yLabel,
  onDotSelect,
  xGetter,
  yGetter,
  rGetter,
  fGetter,
  x,
  y,
}) => {
  const { margin, innerHeight } = measurement

  return (
    <g transform={`translate(${margin.left},${margin.top})`}>
      {data
        .sort((a, b) => rGetter(b) - rGetter(a))
        .filter(d => xGetter(d) && yGetter(d))
        .map((d, i) => {
          const cx = x(xGetter(d))
          const cy = y(yGetter(d))
          const r = calcRValue({ rValue: rGetter(d), rScale, defaultRadius })
          const cProps = {
            key: i,
            cx,
            cy,
            r,
            fill: fillScale ? fillScale(fGetter(d)) : undefined,
            onMouseEnter:
              onDotSelect && (() => onDotSelect({ cy, cx, r, data: d })),
            onMouseLeave: onDotSelect && (() => onDotSelect()),
          }

          return R.isNil(circleRenderer) ? (
            <Circle {...cProps} />
          ) : (
            circleRenderer({ ...cProps, data: d })
          )
        })}
      <Axis dy={innerHeight} axis={axisBottom(x).tickFormat(xFormat)} />
      <Axis axis={axisLeft(y).tickFormat(yFormat)} />
      <g transform="rotate(270) translate(0,10)">
        <YLabel>{yLabel}</YLabel>
      </g>
      <g
        transform={`translate(${
          measurement.innerWidth
        },${measurement.innerHeight - 10})`}
      >
        <XLabel>{xLabel}</XLabel>
      </g>
    </g>
  )
}
export default pure(ScatterPlot)
